// This file is auto-generated by generate-locales.sh

export const SUPPORTED_LANGUAGES = ["ar", "az", "bg", "bn", "bs", "cs", "da", "de", "el", "en", "es", "et", "fa", "fi", "fr", "gu", "he", "hi", "hr", "hu", "hy", "id", "it", "ja", "ka", "kk", "ko", "ky", "lt", "lv", "mk", "ml", "mr", "ms", "nb", "ne", "nl", "pa", "pl", "pt", "ro", "sk", "sl", "sq", "sr-Latn", "sv", "ta", "te", "tg", "th", "tl", "tr", "uk", "ur", "uz", "vi", "zh-Hans", "zh-Hant"];

// Native language names for languages where Intl.DisplayNames may return wrong/English results
export const LANGUAGE_NAMES: Record<string, string> = {
  "sr-Latn": "Srpski (latinica)",
  "nb": "Norsk bokmål",
  "tl": "Filipino",
};

export const LANGUAGE_FLAGS: Record<string, string> = {
  "ar": "SA", // Arabic -> Saudi Arabia
  "az": "AZ", // Azerbaijani -> Azerbaijan
  "bg": "BG", // Bulgarian -> Bulgaria
  "bn": "BD", // Bengali -> Bangladesh
  "bs": "BA", // Bosnian -> Bosnia and Herzegovina
  "cs": "CZ", // Czech -> Czech Republic
  "da": "DK", // Danish -> Denmark
  "de": "DE", // German -> Germany
  "el": "GR", // Greek -> Greece
  "en": "GB", // English -> United Kingdom
  "es": "ES", // Spanish -> Spain
  "et": "EE", // Estonian -> Estonia
  "fa": "IR", // Persian -> Iran
  "fi": "FI", // Finnish -> Finland
  "fr": "FR", // French -> France
  "gu": "IN", // Gujarati -> India
  "he": "IL", // Hebrew -> Israel
  "hi": "IN", // Hindi -> India
  "hr": "HR", // Croatian -> Croatia
  "hu": "HU", // Hungarian -> Hungary
  "hy": "AM", // Armenian -> Armenia
  "id": "ID", // Indonesian -> Indonesia
  "it": "IT", // Italian -> Italy
  "ja": "JP", // Japanese -> Japan
  "ka": "GE", // Georgian -> Georgia
  "kk": "KZ", // Kazakh -> Kazakhstan
  "ko": "KR", // Korean -> South Korea
  "ky": "KG", // Kyrgyz -> Kyrgyzstan
  "lt": "LT", // Lithuanian -> Lithuania
  "lv": "LV", // Latvian -> Latvia
  "mk": "MK", // Macedonian -> North Macedonia
  "ml": "IN", // Malayalam -> India
  "mr": "IN", // Marathi -> India
  "ms": "MY", // Malay -> Malaysia
  "nb": "NO", // Norwegian Bokmål -> Norway
  "ne": "NP", // Nepali -> Nepal
  "nl": "NL", // Dutch -> Netherlands
  "pa": "IN", // Punjabi -> India
  "pl": "PL", // Polish -> Poland
  "pt": "PT", // Portuguese -> Portugal
  "ro": "RO", // Romanian -> Romania
  "sk": "SK", // Slovak -> Slovakia
  "sl": "SI", // Slovenian -> Slovenia
  "sq": "AL", // Albanian -> Albania
  "sr-Latn": "RS", // Serbian (Latin) -> Serbia
  "sv": "SE", // Swedish -> Sweden
  "ta": "IN", // Tamil -> India
  "te": "IN", // Telugu -> India
  "tg": "TJ", // Tajik -> Tajikistan
  "th": "TH", // Thai -> Thailand
  "tl": "PH", // Tagalog -> Philippines
  "tr": "TR", // Turkish -> Turkey
  "uk": "UA", // Ukrainian -> Ukraine
  "ur": "PK", // Urdu -> Pakistan
  "uz": "UZ", // Uzbek -> Uzbekistan
  "vi": "VN", // Vietnamese -> Vietnam
  "zh-Hans": "CN", // Chinese (Simplified) -> China
  "zh-Hant": "TW", // Chinese (Traditional) -> Taiwan
};
